import { lazy, Suspense } from "react";
import { Route, Routes as RouterRoutes, useLocation } from "react-router-dom";

import PageLoader from "./components/Common/PageLoader";

import Base from "./components/Layout/Base";
import LoginBasePage from "./components/Layout/LoginBasePage";

const Login = lazy(() => import("./components/Pages/Login"));
const Challenge = lazy(() => import("./components/Pages/Challenge"));
const OMS = lazy(() => import("./oms/index"));

const listofPages = ["/login", "/challenge"];

const Routes = () => {
  const location = useLocation();

  if (listofPages.indexOf(location.pathname) > -1) {
    return (
      <LoginBasePage>
        <Suspense fallback={<PageLoader />}>
          <RouterRoutes location={location}>
            <Route path="/login" element={<Login />} />
            <Route path="/challenge" element={<Challenge />} />
          </RouterRoutes>
        </Suspense>
      </LoginBasePage>
    );
  }

  return (
    <Base>
      <Suspense fallback={<PageLoader />}>
        <RouterRoutes location={location}>
          <Route path="/dockets" element={<OMS />} />
          <Route path="/" element={<OMS />} />
        </RouterRoutes>
      </Suspense>
    </Base>
  );
};

export default Routes;
